





import { defineComponent } from '@vue/composition-api';

import PageColumnWithVisitorEditor from '@/components/Visitor/PageColumnWithVisitorEditor.vue';

const New = defineComponent({
  components: {
    PageColumnWithVisitorEditor,
  },
  // setup() {},
});

export default New;
